import GetInfoModal from './GetInfoModal'

export default GetInfoModal;
